import React from 'react';
import SiteHtmlPage from '../components/siteContent/SiteHtmlPage';

const TermsPage = () => <SiteHtmlPage slug="terms" />;

export default TermsPage;
